import React from 'react'
import { PageCreate } from '@homeviews/outreach'

export const OutreachCreate = () => <PageCreate />
